import React from "react";
import { Lock, ArrowRight } from "@phosphor-icons/react";

/**
 * Full-panel empty state used in place of a server-backed view when the
 * visitor is browsing as a guest (no account / not signed in).
 *
 * Backend-required surfaces (Appointments, Prescriptions, Symptoms,
 * Calendar Sync, Share Links, Backups, Billing, Admin) render this gate
 * instead of their normal contents so guests still see *what* the feature
 * is, without us silently 401'ing in the background.
 */
export default function GuestGate({ title, description, bullets = [], onSignIn, testId }) {
  return (
    <div className="guest-gate" data-testid={testId || "guest-gate"}>
      <div className="guest-gate-icon" aria-hidden="true">
        <Lock size={28} weight="duotone" />
      </div>
      <h2 className="guest-gate-title">{title}</h2>
      <p className="guest-gate-desc">{description}</p>
      {bullets.length > 0 && (
        <ul className="guest-gate-bullets" data-testid={`${testId || "guest-gate"}-bullets`}>
          {bullets.map((b) => (
            <li key={b}>{b}</li>
          ))}
        </ul>
      )}
      <button
        type="button"
        className="btn btn--accent guest-gate-cta"
        onClick={onSignIn}
        data-testid={`${testId || "guest-gate"}-signin`}
      >
        Create a free account <ArrowRight size={14} weight="bold" />
      </button>
      <p className="guest-gate-fineprint">
        Already have an account? <button type="button" className="link-btn" onClick={onSignIn} data-testid={`${testId || "guest-gate"}-login-link`}>Sign in</button>.
      </p>
    </div>
  );
}
